
const interviewsList = [
    {
        title: "CWC Global: Devastated with director Ashish Avikunthak and Cinematographer Rumi",
        link: "https://www.youtube.com/watch?v=mVO2nLmc4cs&t=6s",
    },
    {
        title: "MIT Fall 2025 Architecture Lecture Series",
        link: "https://www.youtube.com/watch?v=aaTJmFhdv9M",
    },
    {
        title: "A Conversation with Ashish Avikunthak",
        link: "https://www.youtube.com/watch?v=UkKeQqsYEms&t=2985s",
    },
    {
        title: "Ashish Avikunthak VIDcast by Imagine Heritage NPO",
        link: "https://www.youtube.com/watch?v=CJb0jWWlhVY",
    },
    {
        title: "𝗔𝘀𝗵𝗶𝘀𝗵 𝗔𝘃𝗶𝗸𝘂𝗻𝘁𝗵𝗮𝗸 | Lecture and Film Screening | EAEFF Satellite Programmes",
        link: "https://www.youtube.com/watch?v=B-wK703sXzc&t=1598s",
    },
    {
        title: "EL CINEMATÓGRAFO / VIEJOS PROGRAMAS (12). EL CINE DE ASHISH AVIKUNTHAK",
        link: "https://www.youtube.com/watch?v=pJJs0wP6Rag",
    },
    {
        title: "IFFR Interview - Glossary of Non Human Love",
        link: "https://www.youtube.com/watch?v=zKyWBmC1ulY",
    },
    {
        title: "Ashish Avikunthak I Podcast Part 2 | Single Take Film - Rati Chakravyuh | Basab Mullik",
        link: "https://www.youtube.com/watch?v=CfSVYLt238k&t=3s",
    },
    {
        title: "Ashish Avikunthak I Podcast Part 1 | Digital Cinema | Rati Chakravyuh I Basab Mullik",
        link: "https://www.youtube.com/watch?v=6y_8Zy7RR-M",
    },
    {
        title: "Remembering Kumar Shahani (Part 1)",
        link: "https://www.youtube.com/watch?v=x1XV9xPaY-U",
    },
    {
        title: "Remembering Kumar Shahani (Part 2)",
        link: "https://www.youtube.com/watch?v=pHgkQ8_SICw",
    },
    {
        title: "Dispassionate Love (2018) | Experimental Filmmaker Ashish Avikunthak With N. Rashed Chowdhury",
        link: "https://www.youtube.com/watch?v=H86ZMS_B9Jo",
    },
    {
        title: "IG LIVE: Ashish Avikunthak in conversation with Ashish Rajadhyaksha",
        link: "https://www.youtube.com/watch?v=R9DlBzjk0ws",
    },
    {
        title: "Ashish Avikunthak: Bureaucratic Archaeology, The Working of ASI",
        link: "https://www.youtube.com/watch?v=DJI1eY2qRGE",
    },
    {
        title: "How the Indian Art Market and the Gallery System Operate : A Conversation with Ashish Avikunthak",
        link: "https://www.youtube.com/watch?v=9YOYaBvR63k",
    },
    {
        title: "Q & A - Issues in Cinema",
        link: "https://www.youtube.com/watch?v=TwTqpO8_6gQ",
    },
    {
        title: "Interview With Ashish Avikuntak | At ISFFI Bhopal| Neelesh Singh Sisodia | 2020",
        link: "https://www.youtube.com/watch?v=dA6rxgIBy-s",
    },
    {
        title: "Audiogyan Ep. 14: A film artist",
        link: "https://www.youtube.com/watch?v=qx8A7EePPGg",
    },
    {
        title: "People of India Interview, 20 March 2017",
        link: "https://www.youtube.com/watch?v=dhkIpvQ068k",
    },
    {
        title: "Kalkimanthankatha | The Churning of Kalki Q&A at New York University, 2016",
        link: "https://www.youtube.com/watch?v=B7mQY7C3nbo",
    },
    {
        title: "Rati Chakravyuh Q&A at Slought, University of Pennsylvania, 2015",
        link: "https://www.youtube.com/watch?v=I-a1IImk5MA",
    },
    {
        title: "29 12 2012 Q & A Session with Ashish Avikunthak, Film Maker",
        link: "https://www.youtube.com/watch?v=xuKIe47VR-k",
    },
    {
        title: "29 12 2012 Mr. Amrit Gangar talks about Ashish and his work.",
        link: "https://www.youtube.com/watch?v=wa92oqgTLqk",
    },
    {
        title: "29 12 2012 Mr.Amrit Gangar talks about Ashish and his work. (Part II)",
        link: "https://www.youtube.com/watch?v=UXC9YD-d_pQ",
    },
    {
        title: "THE FD ZONE Film Club",
        link: "https://www.youtube.com/watch?v=s-nHA7UGyOs",
    },
];

export default interviewsList;




















